<div class="autocomplete-overlay">
  <am-places-autocomplete-search-input
    #searchInput
    [control]="searchControl"
    (close)="closeSearch.emit()">
  </am-places-autocomplete-search-input>

  <ng-container *ngIf="(searchState$ | async) as state">
    <div class="content-area">
      <ng-container *ngIf="!state.hasSearched">
        <div class="info-content">
          <i class="fa-map-search"></i>
          <h3>
            {{ 'paxForms.destinationAddressAutocomplete.destinationAddressTitle' | translate }}
          </h3>
          <p>
            {{ 'paxForms.destinationAddressAutocomplete.destinationAddressSubtitle' | translate }}
          </p>
        </div>
      </ng-container>

      <ng-container *ngIf="state.hasSearched && !state.error && state.results.length === 0">
        <div class="info-content">
          <i class="fa-search-caution"></i>
          <h3>
            {{ 'paxForms.destinationAddressAutocomplete.addressNotFoundTitle' | translate }}
          </h3>
          <p>
            {{ 'paxForms.destinationAddressAutocomplete.addressNotFoundSubtitle' | translate }}
          </p>
        </div>
      </ng-container>

      <ng-container *ngIf="state.error && state.hasSearched">
        <div class="info-content">
          <i class="fa-search-caution"></i>
          <h3>
            {{ 'paxForms.destinationAddressAutocomplete.searchErrorTitle' | translate }}
          </h3>
          <p>
            {{ 'paxForms.destinationAddressAutocomplete.searchErrorSubtitle' | translate }}
          </p>
          <button class="manual-btn" (click)="closeSearch.emit()">
            {{ 'paxForms.destinationAddressAutocomplete.searchErrorButton' | translate }}
          </button>
        </div>
      </ng-container>

      <ng-container *ngIf="state.results.length > 0">
        <am-places-autocomplete-result-list
          #resultsList
          class="list-component"
          [results]="state.results"
          [searchTerm]="searchControl.value"
          (placeSelected)="onPlaceSelected($event)">
        </am-places-autocomplete-result-list>

        <div class="scroll-actions">
          <am-places-autocomplete-scroll-controls
            [disableUp]="!canScrollUp"
            [disableDown]="!canScrollDown"
            (scrollUp)="resultsList.scroll('up')"
            (scrollDown)="resultsList.scroll('down')">
          </am-places-autocomplete-scroll-controls>
        </div>
      </ng-container>
    </div>
  </ng-container>
</div>